import React from "react";
import arrowIcon from "../main/assets/img/icons/up-arrow.png"
// import "../main/assets/styles/buttons.scss"

const arrowButton = ({buttonTxt,onClick}) => {
  return (
    <div className="arrowBtnMain">
      <button onClick={onClick} type="button" className="arrowButton">
      {buttonTxt}
        <span className="iconBox">
            <img src={arrowIcon} alt="arrow icon" />
        </span>
      </button>
    </div>
  );
};

export default arrowButton;
